<template>
    <div v-if="fetched">
        <!-- Form Example -->
        <d-list-group flush>
            <d-list-group-item class="p-3">
                <d-form>
                    <d-form-row>
                        <d-col md="6" >
                            <fieldset class="form-group">
                                <label>Rodzaj kontaktu</label>
                                <d-select name="type"
                                          v-model="contact.type"
                                          @input="lar_errors.clear('type')"
                                          :class="{'is-invalid' : lar_errors.has('type')}"
                                          placeholder="">
                                    <option value="">--Wybierz rodzaj</option>
                                    <option value="phone">Telefoniczny</option>
                                    <option value="email">E-mail</option>
                                    <option value="post">Poczta</option>
                                </d-select>
                                <div class="invalid-feedback" v-text="lar_errors.get('type')"></div>
                            </fieldset>
                            <fieldset class="form-group">
                                <label for="name">Notka</label>
                                <textarea id="description"
                                            type="text"
                                            name="description"
                                            class="form-control"
                                            v-model="contact.description"
                                            @input="lar_errors.clear('description')"
                                            :class="{'is-invalid' : lar_errors.has('description')}"
                                            placeholder="Opis kontaktu">{{contact.description}}</textarea>
                                <div class="invalid-feedback" v-text="lar_errors.get('description')"></div>
                            </fieldset>
                            <fieldset class="form-group" v-if="!contact.id">
                                <d-checkbox
                                        :value="'1'"
                                        :unchecked-value="'0'"
                                        toggle
                                        v-model="contact.is_costs">
                                    Generuje dodatkowe koszty
                                </d-checkbox>
                            </fieldset>
                            <fieldset class="form-group" v-if="contact.is_costs == '1'">
                                <label for="name">Dodatkowe koszty</label>
                                    <ss-price-input label="Koszty dodatkowe"
                                                    name="costs"
                                                    v-model="contact.costs"
                                    @input="lar_errors.clear('costs')"
                                    :class="{'is-invalid' : lar_errors.has('costs')}"
                                                    :disabled="isCostDisabled"
                                    placeholder="Dodatkowe koszty" />
                                <div class="invalid-feedback" v-text="lar_errors.get('costs')"></div>
                            </fieldset>

                        </d-col>
                        <d-col md="5" offset-md="1" class="form-group">
                            <label>Lista plików</label>
                            <div class="clearboth"></div>
                            <table class="table">
                                <thead>
                                    <th>Plik</th>
                                    <th class="action-cell">Akcja</th>
                                </thead>
                                <tbody>
                                    <tr v-for="(file, index) in contact.files">
                                        <td>
                                            <ss-file v-model="file.file"
                                                     v-if="!file.filename"
                                                     class="mb-0"></ss-file>
                                            <a v-else href="#"@click.prevent="downloadFile(file)">{{file.filename}}</a>
                                        </td>
                                        <td>
                                            <d-button theme="danger"
                                                      @click.prevent="removeFile(file, index)">
                                                <strong>Usuń</strong>
                                            </d-button>
                                        </td>
                                    </tr>
                                <tr>
                                    <td></td>
                                    <td>
                                        <d-button theme="success"
                                                  @click.prevent="addFile">Dodaj</d-button>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </d-col>
                    </d-form-row>
                </d-form>
            </d-list-group-item>
        </d-list-group>
    </div>
</template>

<script>
    import FileSaver from 'file-saver'
    import LarErrors from '../../helpers/Errors';
    import SsPriceInput from '../common/SsPriceInput'

    export default {
        name: "Contact",
        components: {
            LarErrors,
            SsPriceInput
        },
        props: {
            props: {
                type: Object,
                default: {}
            }
        },
        data(){
            return{
                fetched: false,
                lar_errors: LarErrors,
                submitting: false,
                uid: '',
                contact: {
                    id:             '',
                    client_id:      '',
                    type:           '',
                    description:    '',
                    files_to_delete: [],
                    files:          [
                        {
                            file: null
                        }
                    ]
                },
            }
        },
        computed: {
          isCostDisabled(){
              return this.contact.id != '';
          }
        },
        methods: {
            removeFile(file, index){
                if(file.id){
                    if(!this.contact.files_to_delete){
                        this.this.contact.files_to_delete = [];
                    }
                    this.contact.files_to_delete.push(file.id);
                }
                this.contact.files.splice(index, 1)
            },
          addFile(){
              this.contact.files.push({file: null});
              this.$forceUpdate();
          },
            downloadFile(doc){
                axios.post('api/contact-history/download-client-history-file',
                    {id: doc.id,},
                    {responseType: 'blob'}
                ).then(response => {
                    let blob = new File([response.data], doc.filename );
                    FileSaver.saveAs(blob);
                }).catch((error)=>{
                    Vue.swal({
                        title: 'Nie udało się pobrać pliku',
                        text: 'Wystąpił błąd podczas pobierania. Spróbuj ponownie za jakiś czas.',
                        type: 'error',
                    });
                });
            },
        },
        mounted(){
            this.contact = this.props ? this.props : this.contact;
            this.fetched = true;
            this.uid = this._uid;
            this.$forceUpdate();
        },
        watch: {
            props: {
                handler: function(to) {
                    this.contact = to;
                    this.$forceUpdate();
                },
                deep: true
            }
        }
    }
</script>

<style scoped>
    textarea#description {
        min-height: 150px;
    }
</style>
